import { createDCHook, collapseDataFromCall } from '../client';
import { getUsageCap } from '../services/UsageCapService';

export const useUsageCapGetUsageCap = createDCHook('getUsageCap', collapseDataFromCall(getUsageCap), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});
